export function patronageFeaturesInit() {
    const selectors = {
        main: '.b-patronage-features',
        item: '.b-patronage-features__item',
        row: '.b-patronage-features__row',
    };
    
    $(selectors.main).each((index, elem) => {
        const $elem = $(elem);
        const elems = {
            $main: $elem,
            $items: $elem.find(selectors.item),
            $rows: $elem.find(selectors.row),
            $window: $(window)
        };
    
        setEqualRowsHeights();
    
        elems.$window.resize(() => {
            setEqualRowsHeights();
        })
        
        function setEqualRowsHeights() {
            elems.$rows.css('height', '');
            
            if (elems.$window.width() > 767) {
                const heightsArray = getMaxHeightsArray();
    
                heightsArray.forEach((height, index) => {
                    elems.$items.find(`${selectors.row}:nth-child(${index + 1})`).height(height);
                })
            }
        }
        
        function getMaxHeightsArray() {
            let maxHeightsArray = [],
                rowHeight;
    
            elems.$items.each((itemIndex, item) => {
                $(item).find(selectors.row).each((rowIndex, row) => {
                    rowHeight = $(row).height();
            
                    if (!maxHeightsArray[rowIndex] || rowHeight > maxHeightsArray[rowIndex]) {
                        maxHeightsArray[rowIndex] = rowHeight;
                    }
                })
            })
            
            return maxHeightsArray;
        }
    })
}
